(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/match-list.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/match-list.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.MatchList = Backbone.Marionette.CollectionView.extend({
    tagName: 'ul',
    className: function() {
      return svs.maltipset.models.tipsInfo.tipsInfoActive()
        ? 'list-group tipsinfo-visible'
        : 'list-group';
    },
    childView: svs.maltipset.views.MatchListItem,
    initialize: function() {
      this.listenTo(
        svs.maltipset.models.tipsInfo,
        'change',
        this.tipsInfoChanged,
        this
      );
    },
    tipsInfoChanged: function() {
      this.$el.toggleClass(
        'tipsinfo-visible',
        svs.maltipset.models.tipsInfo.tipsInfoActive()
      );
    }
  });
})(Backbone, _, svs);

 })(window);